import axios from "axios";
import settings from "@/settings";
import router from "@/router";

let newBulkPaymentsHistorySearchData = {
    company_name: null,
    start_date: null,
    end_date: null,
    bank_name: null,
    status: null,
};


export default {
    namespaced: true,
    state: {
        bulkPaymentHistoryTableOptions: null,
        bulkPaymentHistoryTotalCount: 0,
        bulkPaymentsHistorySearch: {...newBulkPaymentsHistorySearchData},
        loadingBulkPaymentsHistoryList: false,
        loadingBulkPaymentData: false,
        activeBulkPayment: {},
        bulkPaymentsHistory: [],
    },
    mutations: {
        setBulkPayments(state, val) {
            state.bulkPaymentsHistory = val;
        },
        setBulkPaymentHistoryDataLoading(state, bool) {
            state.loadingBulkPaymentData = bool;
        },
        setActiveBulkPayment(state, value) {
            state.activeBulkPayment = value;
        },
        setBulkPaymentsHistoryListLoading(state, bool) {
            state.loadingBulkPaymentsHistoryList = bool;
        },
        updateBulkPaymentsHistorySearch(state, {prop, value}) {
            if (value === "") value = null;
            state.bulkPaymentsHistorySearch = {
                ...state.bulkPaymentsHistorySearch,
                [prop]: value
            };
        },
        updateBulkPaymentsHistoryDateSearch(state, payload) {
            state.bulkPaymentsHistorySearch = {...state.paymentsHistorySearch, ...payload};
        },
        resetBulkPaymentsHistorySearch(state) {
            state.bulkPaymentsHistorySearch = {...newBulkPaymentsHistorySearchData};
        },
        setBulkPaymentsTotalCount(state, value) {
            state.bulkPaymentHistoryTotalCount = value;
        },
        setBulkPaymentHistoryTableOptions(state, options) {
            state.bulkPaymentHistoryTableOptions = options;
        },
    },
    actions: {
        async getBulkPaymentsHistory({commit, state}) {
            commit("setBulkPaymentsHistoryListLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let options = state.bulkPaymentHistoryTableOptions;
                let search = state.bulkPaymentsHistorySearch;
                let params = {
                    company_name: search && search.company_name ? search.company_name : null,
                    start_date: search && search.start_date ? search.start_date : null,
                    end_date: search && search.end_date ? search.end_date : null,
                    status: search && search.status ? search.status : null,
                    swift: search && search.swift ? search.swift : null,
                    bank_name: search && search.bank_name ? search.bank_name : null,
                    page: options && options.page ? options.page : null,
                    itemsPerPage: options && options.itemsPerPage ? options.itemsPerPage : null,
                    sortBy: options && options.sortBy[0] ? options.sortBy[0] : null,
                    sortDesc: options && options.sortDesc ? options.sortDesc[0] : null
                };
                const response = await axios.get(settings.app_url + "/bulk-payments-history/", {params});
                const data = response.data;
                if (data.success === 1) {
                    await commit("setBulkPayments", data.bulk_payments);
                    await commit("setBanks", data.bank_array, {root: true});
                    await commit("setBulkPaymentsTotalCount", data.total_bulk_payments_count);
                } else {
                    commit("setBulkPayments", []);
                }
            } catch (e) {
                console.log("- ERROR -");
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setBulkPaymentsHistoryListLoading", false);
        },
        async getBulkPaymentData({commit}, {paymentId}) {
            commit("setBulkPaymentHistoryDataLoading", true);
            commit("setRequestSuccess", false, {root: true});
            commit("setRequestError", false, {root: true});
            try {
                let response = await axios.get(settings.app_url + "/bulk-payment-history/" + paymentId);
                if (response && response.data && response.status === 200 && response.data.success === 1) {
                    let data = response.data;
                    commit("setActiveBulkPayment", data.bulk_payment_data);
                } else {
                    commit("setActiveBulkPayment", {});
                    //commit("toggleDrawer", false);
                    router.push("/admin/bulk-payments-history");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true, {root: true});
                commit("setErrorMessage", "Failed", {root: true});
            }
            commit("setBulkPaymentHistoryDataLoading", false);
        },
    }
}